import Vue from 'vue'
import router from './router'
import App from './App.vue'
import store from 'vx/store'
import VeeValidate from 'vee-validate'
import HelpBlock from 'components/form/HelpBlock'
import CodiumVue from '@codium/codium-vue'
import ChameleonVue from '@chameleon/chameleon-vue'

import 'utils/http'
import 'utils/validation'
import 'filters'
import 'directives'
import 'utils/components'

import 'jquery'

// Polyfills
import 'pathseg'

window.moment = require('moment');
var metisMenu = require('metismenu');
window.slimScroll = require('jquery-slimscroll/jquery.slimscroll.js');
window.markdown = require( "markdown" ).markdown;

import VueSweetAlert from 'vue-sweetalert'
Vue.use(VueSweetAlert)
Vue.use(CodiumVue)
Vue.use(ChameleonVue)

import VueFlatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
Vue.use(VueFlatPickr);

// Configure our HTTP client
var rest = require('rest')
var pathPrefix = require('rest/interceptor/pathPrefix')
var mime = require('rest/interceptor/mime')
var defaultRequest = require('rest/interceptor/defaultRequest')
var errorCode = require('rest/interceptor/errorCode')
var interceptor = require('rest/interceptor')
var jwtAuth = require('./interceptors/jwtAuth')
var pusher = require('./interceptors/pusher')
var timeout = require('rest/interceptor/timeout')

window.client = rest.wrap(pathPrefix, { prefix: process.env.VUE_APP_API_URL })
                    .wrap(mime)
                    .wrap(defaultRequest, {
			headers: {
				'X-Requested-With': 'XMLHttpRequest',
				'Content-Type': 'application/json'

			}
		})
                    .wrap(errorCode, { code: 400 })
                    .wrap(jwtAuth)
                    .wrap(pusher)
                    .wrap(timeout, { timeout: 50000 });


/**
 * Global Componenets
 */
Vue.component('help-block', HelpBlock)

Vue.use(VeeValidate, {
    events: 'blur',
    inject: false,
    classes: true,
    classNames: {
        valid: 'is-valid',
        invalid: 'is-invalid'
   }
})

Vue.component('my-currency-input', {
    props: ["value"],
    template: `
        <input type="text" v-model="displayValue" @blur="blur" @focus="isInputActive = true"/>
    `,
    data: function() {
        return {
            isInputActive: false
        }
    },
    computed: {
        displayValue: {
            get: function() {
                if (this.isInputActive) {
                    // Cursor is inside the input field. unformat display value for user
                    return this.value.toString()
                } else {
                    // User is not modifying now. Format display value for user interface
                    
                    return this.value ? this.value.toFixed(2).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,") : 0.00
                }
            },
            set: function(modifiedValue) {
                // Recalculate value after ignoring "$" and "," in user input
                let newValue = parseFloat(modifiedValue.replace(/[^\d\.]/g, ""))
                // Ensure that it is not NaN
                if (isNaN(newValue)) {
                    newValue = 0
                }
                // Note: we cannot set this.value as it is a "prop". It needs to be passed to parent component
                // $emit the event so that parent component gets it
                this.$emit('input', newValue)
            }
        }
    },
    methods: {
        blur() {
            this.isInputActive = false
            this.$emit('blur');
        }
    }
});

//Vue.config.performance = true;


/**
* Custom filters
*/

Vue.filter('moment', function() {
    var args = Array.prototype.slice.call(arguments),
        value = args.shift(),
        date = moment(value);

    if (!date.isValid()) return '';

    function parse() {
        var args = Array.prototype.slice.call(arguments).map(function(str) { return str.replace(/^("|')|("|')$/g, ''); }),
            method = args.shift();

            var format = method;
            date = date.format(format);

            if (args.length) parse.apply(parse, args);
    }

    parse.apply(parse, args);

    return date;
});

Vue.filter('fromNow', function() {
    var args = Array.prototype.slice.call(arguments),
        value = args.shift(),
        date = moment(value);

    if (!date.isValid()) return '';

    return date.fromNow();
});


Vue.filter('percent', function() {
    var args = Array.prototype.slice.call(arguments),
        value = args.shift(),
        input = value;

    input = (input * 100).toFixed(1) + '%';

    return input;
});

Vue.filter('rate', function() {
    var args = Array.prototype.slice.call(arguments),
        value = args.shift(),
        input = value;

    if (input > 0) {
      input = (input * 100).toFixed(2) + '%';
    }

    return input;
});

Vue.filter('currency', function() {
    var args = Array.prototype.slice.call(arguments),
        value = args.shift(),
        input = parseFloat(value);

    if (input > 0) {
      input = (input).toFixed(2);
    }

    return input.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
});

Vue.filter('currency0', function() {
    var args = Array.prototype.slice.call(arguments),
        value = args.shift(),
        input = 0

    if (value != null) {
      input = parseFloat(value)
    }

    if (input > 0) {
      input = (input).toFixed(0);
    }

    return input.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
});

Vue.filter('invoiced', function (array)
{
    return array.filter(function(item) {
        return item.invoice_id == null;
    })

});

Vue.prototype.$bus = new Vue()
Vue.prototype.$status = new Vue()


Vue.prototype.$store = new Vue({
  data: {
  	clients: [],
  	users: [],
  	view: {
  		userstories: {
  			showTimes: false,
  			showDescrption: false,
  			collapsed: true,

  		}
  	},
  }
})

/**
* Any random jQuery loading
*/
$(document).ready(function() {

    // Add body-small class if window less than 768px
    if ($(this).width() < 769) {
        $('body').addClass('body-small')
    } else {
        $('body').removeClass('body-small')
    }

    // Minimalize menu
    $('.navbar-minimalize').click(function () {
        $("body").toggleClass("mini-navbar");
        SmoothlyMenu();
    });

    // Move modal to body
    // Fix Bootstrap backdrop issu with animation.css
    $('.modal').appendTo("body");

    // Minimalize menu when screen is less than 768px
    $(window).bind("resize", function () {
        if ($(this).width() < 769) {
            $('body').addClass('body-small')
        } else {
            $('body').removeClass('body-small')
        }
    });

    // Add slimscroll to element
    $('.full-height-scroll').slimscroll({
        height: '100%'
    })

});

new Vue({
    router,
    store,
    render: h => h(App)
  }).$mount('#app')

